import { getMinPriceInfo, getSubscriptionPriceInfo } from 'shared/utils/deal-info-helpers';


export const OVERLAY_ACTION_TYPES = {
  TIMER: 'timer',
  FILM: 'film',
  BUY_RENT: 'buy-rent',
  INFO: 'info',
  SHARE: 'share',
  SUBSCRIBE: 'subscribe',
};

export function getOverlayActions(settings, channel, videoItem) {
  const { dealInfo, dgsInfo } = videoItem;

  const actions = [];
  const minVideoPriceInfo = getMinPriceInfo(dealInfo);
  const isSubscribed = Boolean(_.get(channel, 'dgsInfo.subscription'));
  const isSubscriptionEnabled = Boolean(getSubscriptionPriceInfo(channel.dealInfo));

  if (dgsInfo) {
    const rentInfo = _.get(dgsInfo, 'rent');
    const saleInfo = _.get(dgsInfo, 'sale');

    if (rentInfo && rentInfo.expirationTs) {
      actions.push(OVERLAY_ACTION_TYPES.TIMER);
    }

    if (saleInfo) {
      actions.push(OVERLAY_ACTION_TYPES.FILM);
    }
  }

  if (minVideoPriceInfo && !isSubscribed && !dgsInfo) {
    if (isSubscriptionEnabled && channel.subscriptionOnly) {
      actions.push(OVERLAY_ACTION_TYPES.SUBSCRIBE);
    } else {
      actions.push(OVERLAY_ACTION_TYPES.BUY_RENT);
    }
  }

  if (settings.booleans.showFullInfo) {
    actions.push(OVERLAY_ACTION_TYPES.INFO);
  }

  if (settings.booleans.enableVideosSharing) {
    actions.push(OVERLAY_ACTION_TYPES.SHARE);
  }

  return actions;
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/player/overlay-actions/overlay-action-utils.js